import React, { useState } from "react";
import Sidebar from "../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar";
// import WorkerTopbar from "../../components/serviceprovider/workerdashboard/workertopbar/WorkerTopbar";
import "../../assets/css/screens/serviceprovider/layouts/workermasterlayout/WorkerMasterLayout.css";

const MasterLayout = ({ children }) => {
  const [activeMenu,    setActiveMenu]    = useState("dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
  const closeSidebar  = () => setIsSidebarOpen(false);

  return (
    <div className="worker-layout">

      {/* ── MOBILE TOPBAR (hidden on desktop via CSS) ── */}
      {/* <WorkerTopbar onMenuClick={toggleSidebar} /> */}

      {/* SIDEBAR */}
      <Sidebar
        isOpen={isSidebarOpen}
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        onClose={closeSidebar}
      />

      {/* MAIN CONTENT */}
      <div className="layout-main">
        <main className="layout-content">
          {children}
        </main>
      </div>

      {/* OVERLAY — mobile sidebar ke peeche */}
      {isSidebarOpen && (
        <div className="wml-sidebar-overlay" onClick={closeSidebar} />
      )}

    </div>
  );
};

export default MasterLayout;